import {
  ContactFormDto,
  ContactFormSchemaDto,
} from '@/domains/contact/application/dto/createContact.dto'
import { ApiMessageResponse } from '@/types/api.types'
import { fetcher } from '@/utils/fetcher'
import { parseOrThrow } from '@/validators/parseOrThrow'

export async function sendContactApi(
  auth: ContactFormDto
): Promise<ApiMessageResponse> {
  const parsedBody = parseOrThrow(auth, ContactFormSchemaDto)
  const url = '/api/contact'

  return await fetcher<ApiMessageResponse>(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(parsedBody),
  })
}
